import { z } from 'zod';
import { actorSchema, isoDateTimeSchema } from './common.ts';

export const noteSchema = z.object({
  id: z.string(),
  requestId: z.string(),
  author: actorSchema,
  body: z.string(),
  createdAt: isoDateTimeSchema,
});
export type Note = z.infer<typeof noteSchema>;

export const createNoteRequestSchema = z.strictObject({
  body: z.string().trim().min(1).max(4000),
});
export type CreateNoteRequest = z.infer<typeof createNoteRequestSchema>;
